import React from "react";
import ApplicationListContent from "./ApplicationListContent";

function ApplicationList() {
	return <ApplicationListContent />;
}

export default ApplicationList;
